export const PRODUCTS: { id: string; name: string }[] = [
  { id: "talenta", name: "Talenta" },
  { id: "jurnal", name: "Jurnal" },
  { id: "qontak_crm", name: "Qontak CRM" },
  { id: "qontak_chat", name: "Qontak Chat" },
  { id: "klikpajak", name: "Klikpajak" },
  { id: "mekari_sign", name: "Mekari Sign" },
];
